<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { UiToastHost } from '@fcms/ui'
import PortalShell from '@/components/PortalShell.vue'

const route = useRoute()
// Public pages (login, /verify/:code, the sports pages) are full-bleed, no
// account, no bottom nav — they must render correctly for someone with no
// session standing on a jetty.
const showShell = computed(() => !route.meta.public)
</script>

<template>
  <PortalShell v-if="showShell">
    <router-view />
  </PortalShell>
  <router-view v-else />
  <UiToastHost />
</template>
